import React from "react"
import { default as NextHead } from "next/head"
import { usePathData } from "@/lib/contexts/appContext"

export default function Head() {
  const { head } = usePathData()

  return (
    <NextHead>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {head &&
        head.map((meta, index) => {
          const Tag = meta.tag
          const attrs = meta.attrs

          if (meta.tag === "title") {
            return <Tag key={index}>{attrs.innerText}</Tag>
          }

          if (meta.tag === "script") {
            return <Tag key={index} type="text/javascript" src={attrs.src} />
          }

          if (meta.tag === "meta" && attrs.name === "robots") {
            return (
              <Tag
                key={index}
                name={attrs.name}
                content={Object.values(attrs.content).join(", ")}
              />
            )
          }

          if (
            typeof attrs.content === "object" &&
            attrs?.property === "og:images"
          ) {
            const { ...content } = attrs
            const [url, props] = Object.entries(content?.content)[0]
            return (
              <React.Fragment key={index}>
                <meta property="og:image" content={url} />
                <meta property="og:image:width" content={props.width} />
                <meta property="og:image:height" content={props.height} />
                <meta property="og:image:secure_url" content={props.url} />
              </React.Fragment>
            )
          }

          return <Tag key={index} {...attrs} />
        })}
    </NextHead>
  )
}
